import { useTheme } from '@mui/material/styles'
import { useEffect, useState, useContext, useRef } from 'react'
import { Stack, Box, Typography, List, ListItem, Button } from '@mui/material'
import { motion } from 'framer-motion'
import { useNavigate } from 'react-router-dom'
import Logo from '../../assets/logo'
import groupsaz from '../../assets/groupsaz.jpg'
import houses from '../../assets/houses.jpg'
import harvardall from '../../assets/harvardall.jpg'
import balloons from '../../assets/balloons.jpg'

import { Link } from 'react-router-dom'
import apple from '../../assets/apple.svg'
import google from '../../assets/google.svg'

export const Groups = ({ }) => {
  const Navigate = useNavigate()

  const theme = useTheme()
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <Stack sx={{ width: '100vw', minHeight: '100vh' }} alignItems={'center'}>
      <Stack
        sx={{ width: '100vw', height: 200 }}
        justifyContent={'center'}
        alignItems={'center'}
      >
        <Logo width={200} />
      </Stack>

      <Stack
        direction={'column'}
        sx={{ maxWidth: 600, justifyContent: 'center' }}
        style={{ fontSize: 22, marginBottom: 16 }}
      >
        <motion.div style={{ fontSize: 16, fontWeight: 300, marginBottom: 20 }}>
          Welcome to JoinU for the Harvard community
        </motion.div>
        <motion.div style={{ fontSize: 18, fontWeight: 400, marginBottom: 5 }}>
        JoinU is a socially responsible platform managed by peer students for the entire community. 
        </motion.div>
        <div>
          <div className='flex flex-col gap-6 min-[400px]:flex-row flex-start bg-red p-6'>
            <Link to='https://apps.apple.com/us/app/joinu-harvard/id6459098232'>
              <img
                alt='apple store link'
                className='mx-auto rounded-xl overflow-hidden aspect-video object-cover object-center'
                width='140'
                src={apple}
              />
            </Link>
            <Link to='https://play.google.com/store/apps/details?id=com.elijamunn.joinuharvard&hl=en_US'>
              <img
                alt='apple store link'
                className='mx-auto rounded-xl overflow-hidden aspect-video object-cover object-center'
                width='140'
                src={google}
              />
            </Link>
          </div>
        </div>
        <motion.div style={{ fontSize: 20, fontWeight: 500, marginBottom: 5, marginTop: 30  }}>
          What interests you?
        </motion.div>
        <img
              alt='Screenshot'
              className='mx-auto rounded-xl overflow-hidden aspect-video object-cover object-center'
              height='600'
              src={groupsaz}
              width='800'
            />
        <motion.div style={{ fontSize: 18, fontWeight: 400, marginBottom: 5 }}>
        At JoinU, we believe in building community through intersections of shared interests. JoinU is designed to help you connect with others on Harvard's campus who have similar passions and hobbies or who want to explore something new together. Whether you're looking to discuss the latest scientific discoveries, explore new recipes, or engage in civic activities, there are campus groups for you. Discover exciting groups from SOCO, engaging activities in athletics, and other groups that align with your passions.
        </motion.div>
        <motion.div style={{ fontSize: 20, fontWeight: 500, marginBottom: 5, marginTop: 30 }}>
        Why Join Groups?
        </motion.div>
        <img
              alt='Screenshot'
              className='mx-auto rounded-xl overflow-hidden aspect-video object-cover object-center'
              height='600'
              src={houses}
              width='800'
            />
        <motion.div style={{ fontSize: 18, fontWeight: 400, marginBottom: 30 }}>
        Joining groups, whether tied to your specific Harvard affiliations or reaching beyond, enhances your university experience regardless of your residence—be it Currier at the College, Vanderbilt at the Medical School, Chase at the Business School, or any other on- or off-campus location. JoinU groups enable you to:
        </motion.div>
        <List
          sx={{
            listStyleType: 'decimal',
            pl: 2,
            '& .MuiListItem-root': {
              display: 'list-item',
              pt: 0,
              pb: 0,
              pr: 0,
            },
          }}
        >
          {[
            'Keep track of what is happening in groups that share your interests.',
            'Organize and attend events that appeal to the unique focus of the group.',
            'Build deeper relationships through regular interactions and shared experiences.',
            'Expand your network by meeting new people from different backgrounds but who have similar interests.',
          ].map((d, i) => (
            <ListItem style={{ fontSize: 18, marginBottom: 5 }}>{d}</ListItem>
          ))}
        </List>
        <motion.div style={{ fontSize: 20, fontWeight: 500, marginBottom: 5 }}>
        Create Your Own Group
        </motion.div>
        <img
              alt='Screenshot'
              className='mx-auto rounded-xl overflow-hidden aspect-video object-cover object-center'
              height='600'
              src={balloons}
              width='800'
            />
        <motion.div style={{ fontSize: 18, fontWeight: 400, marginBottom: 30 }}>
        If you can't find a group that matches your interest, why not start your own? Creating a group on JoinU is simple and provides a fantastic opportunity to lead a community and find others like you at Harvard. Or make a private group and just invite your friends. Whether it's about a common hobby, professional interests, or something fun, your group can be about anything that excites you.
        </motion.div>
        <motion.div style={{ fontSize: 20, fontWeight: 500, marginBottom: 5 }}>
        Join Today!
        <img
              alt='Screenshot'
              className='mx-auto rounded-xl overflow-hidden aspect-video object-cover object-center'
              height='600'
              src={harvardall}
              width='800'
            />
        </motion.div>
        <motion.div style={{ fontSize: 18, fontWeight: 400, marginBottom: 30 }}>
        JoinU is accessible to anyone holding a HarvardKey, encompassing undergraduates, graduate students, faculty, and staff. While not an official Harvard application, access to JoinU is exclusive to those with HarvardKey credentials. Don't miss out on the chance to enrich your University experience. Browse existing groups or start your own today and begin building more meaningful connections on campus.
        </motion.div>
        <motion.div style={{ fontSize: 18, fontWeight: 400, marginBottom: 30 }}>
        Join Others, Find U!
        </motion.div>
        <div>
        <div className='flex flex-col gap-6 min-[400px]:flex-row flex-start bg-red px-6'>
            <Link to='https://app.joinu.org'>
              <Button variant='contained' size='large'>
                Login
              </Button>
            </Link>
          </div>
          <div className='flex flex-col gap-6 min-[400px]:flex-row flex-start bg-red p-6'>
            <Link to='https://apps.apple.com/us/app/crimsonzip/id6459098232'>
              <img
                alt='apple store link'
                className='mx-auto rounded-xl overflow-hidden aspect-video object-cover object-center'
                width='140'
                src={apple}
              />
            </Link>
            <Link to='https://play.google.com/store/apps/details?id=com.elijamunn.joinuharvard&hl=en_US&gl=US'>
              <img
                alt='apple store link'
                className='mx-auto rounded-xl overflow-hidden aspect-video object-cover object-center'
                width='140'
                src={google}
              />
            </Link>
          </div>
        </div>
      </Stack>
    </Stack>
  )
}
